var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5078 13H33.4895V37H16.5078V13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15H18V35H11V15ZM32 15H39V35H32.0001L32 15ZM20.0934 24.6645L19.5498 24.8523L22.0793 27.0963C22.2706 27.673 22.0129 27.843 21.8486 28.1455L24.5948 27.7931L24.5232 30.5865L25.092 30.57L24.9679 27.7998L27.7167 28.1292C27.5466 27.766 27.3952 27.5732 27.5526 26.9925L30.0805 24.8665L29.6381 24.7047C29.2764 24.4225 29.7945 23.3459 29.8726 22.6665C29.8726 22.6665 28.3966 23.1795 28.2998 22.911L27.9239 22.1812L26.5812 23.6722C26.4344 23.7078 26.372 23.6488 26.3375 23.5234L26.9579 20.4076L25.9755 20.966C25.8933 21.0016 25.8111 20.9709 25.7569 20.874L24.812 18.9577L23.8378 20.9479C23.7644 21.0192 23.6908 21.0275 23.6298 20.979L22.6945 20.4486L23.2559 23.5401C23.2113 23.6628 23.1043 23.6973 22.9785 23.6309L21.6949 22.1568C21.527 22.4288 21.4132 22.873 21.1912 22.9726C20.9692 23.0659 20.2259 22.7842 19.7276 22.6743C19.8978 23.2952 20.43 24.3267 20.0932 24.6648L20.0934 24.6645Z",
    fill: "#BF0A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.c3dd2342e98fd17682a760eeb202eddb.svg";
export { ForwardRef as ReactComponent };